<h1 class="title">
  <mat-icon>info</mat-icon>
  {{ "imageConflictDialog.title" | translate }}
</h1>

<div *ngIf="!isImage()">
  {{ "imageConflictDialog.fileMessage" | translate }} <span>{{ data.conflictImage.fileName }}</span>
</div>
<div *ngIf="isImage()">
  {{ "imageConflictDialog.imageMessage" | translate }} <span>{{ data.conflictImage.fileName }}</span>
</div>

<div class="images">
  <div>
    <h3>{{ "imageConflictDialog.newImage" | translate }}</h3>
    <img *ngIf="!isVideo()" class="select-card" src="{{ newImagePath }}" onerror="this.src = 'assets/images/nothumbnails.png'" />
    <video *ngIf="isVideo()" class="select-card" src="{{ newImagePath }}" onerror="this.poster = 'assets/images/NotSupported.png'"></video>
  </div>
  <mat-icon class="chevron">chevron_right</mat-icon>
  <div>
    <h3>{{ "imageConflictDialog.existingImage" | translate }}</h3>
    <img *ngIf="!isVideo()" class="select-card" src="{{ data.conflictImage.conflictPath }}" onerror="this.src = 'assets/images/nothumbnails.png'" />
    <video
      *ngIf="isVideo()"
      class="select-card"
      src="{{ data.conflictImage.conflictPath }}"
      onerror="this.poster = 'assets/images/NotSupported.png'"
    ></video>
  </div>
</div>

<div class="actions">
  <div class="top-actions">
    <evc-nav-button type="secondary" variant="square" size="sm" class="checkbox-button" *ngIf="data.options.applyToAllEnabled">
      <mat-checkbox [(ngModel)]="applyToAll"></mat-checkbox>
      <span>{{ "imageConflictDialog.applyToAllImages" | translate }}</span>
    </evc-nav-button>
    <evc-nav-button type="secondary" variant="square" size="sm" class="keep-existing" (click)="action(uploadOption.Skip)">
      {{ "imageConflictDialog.skip" | translate }}
    </evc-nav-button>
    <evc-nav-button type="error-secondary" variant="square" size="sm" class="replace-existing" (click)="action(uploadOption.Replace)">
      {{ "imageConflictDialog.replaceExisting" | translate }}
    </evc-nav-button>
    <evc-nav-button type="secondary" variant="square" size="sm" class="keep-both" (click)="action(uploadOption.KeepBoth)">
      {{ "imageConflictDialog.keepBoth" | translate }}
    </evc-nav-button>
  </div>
  <evc-nav-button variant="square" size="sm" *ngIf="data.options.cancelEnabled" class="cancel" (click)="cancel()">
    {{ "imageConflictDialog.cancel" | translate }}
  </evc-nav-button>
</div>
